import { Icon } from '@iheartjane/reefer';
import type { IconComponentProps } from '@iheartjane/reefer';
import type { SVGProps } from 'react';

type StaticIconProps = Omit<IconComponentProps, 'color'>;

const LiveMenus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="80" height="80" rx="40" fill="white" />
    <path
      d="M35.2501 31H28.672C28.2656 31 27.8997 31.2459 27.7461 31.6221L18.5625 54.1221C18.294 54.7799 18.7779 55.5 19.4883 55.5H60.5118C61.2223 55.5 61.7061 54.7799 61.4377 54.1221L52.254 31.6221C52.1004 31.2459 51.7345 31 51.3281 31H45.0001"
      stroke="#CE349A"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M46.0001 22.4545C46.0001 27.3977 40.5001 32 40.5001 32C40.5001 32 35.0001 27.3977 35.0001 22.4545C35.0001 19.4426 37.463 17 40.5001 17C43.5371 17 46.0001 19.4426 46.0001 22.4545Z"
      fill="#CE349A"
      stroke="#CE349A"
    />
    <circle cx="40.3334" cy="22.6263" r="1.58333" fill="white" />
    <line
      x1="29.5941"
      y1="30.6956"
      x2="62.0941"
      y2="54.6956"
      stroke="#CE349A"
      strokeWidth="2"
    />
    <line
      x1="55.9706"
      y1="39.8824"
      x2="25.9706"
      y2="55.8824"
      stroke="#CE349A"
      strokeWidth="2"
    />
    <line
      x1="22.1975"
      y1="45.0469"
      x2="53.6975"
      y2="35.0469"
      stroke="#CE349A"
      strokeWidth="2"
    />
    <circle cx="40.0001" cy="44" r="1" fill="#CE349A" />
    <circle cx="54.0001" cy="45" r="1" fill="#CE349A" />
    <circle cx="34.0001" cy="38.5" r="1" fill="#CE349A" />
  </svg>
);

export const LiveMenusIcon = ({ size = 'xl', ...props }: StaticIconProps) => {
  return <Icon icon={LiveMenus} {...props} size={size} color={undefined} />;
};
